






































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { LayoutModule } from "@/store/layout";
import { ReportModule } from "@/store/report";
import CampaignsReportFilter from "./CampaignsReportFilter.vue";
import ReportsAPI from "@/services/reports";
import CAMPAIGN_STATUS_LIST from "@/constants/campaign";
import Campaign, { LineItem } from "@/models/campaign";
import CampaignHelper from "@/helpers/campaign";
import Site from "@/models/site";
import SitesAPI from "@/services/sites";
import { QueryParams } from "@/models/general";
import { exportCSVFile } from "@/helpers/general";
import moment from "moment";

@Component
export default class CampaignReport extends Vue {
  data: Campaign[] = [];
  sites: Site[] = [];

  headers = [
    {
      text: this.$t("campaigns.model.name"),
      sortable: false,
      value: "name",
    },
    {
      text: this.$t("campaigns.model.company"),
      sortable: false,
      value: "company",
    },
    {
      text: this.$t("campaigns.model.seller"),
      sortable: false,
      value: "user",
    },
    {
      text: this.$t("campaigns.model.start"),
      sortable: true,
      value: "start",
      width: "120px",
    },
    {
      text: this.$t("campaigns.model.end"),
      sortable: true,
      value: "end",
      width: "120px",
    },
    {
      text: this.$t("reports.campaign.sites"),
      sortable: false,
      value: "lineItems",
    },
    {
      text: this.$t("campaigns.model.status"),
      sortable: false,
      value: "status",
    },
  ];

  @Watch("filter", { deep: true })
  onFilterChange(): void {
    this.getData();
  }

  async created(): Promise<void> {
    const params: QueryParams = {
      page: {
        size: -1,
      },
    };
    const r = await SitesAPI.getSites(params);
    this.sites = r.data;
    this.getData();
  }

  async getData(): Promise<void> {
    const payload = {
      start: ReportModule.startFilter,
      end: ReportModule.endFilter,
    };
    const r = await ReportsAPI.campaignsReport(payload);
    this.data = r;
  }

  exportCsv(): void {
    const headers: string[] = [];
    this.headers.forEach((h) => {
      headers.push(h.text.toString());
    });
    headers.pop();
    const data: any = [];

    this.data.forEach((d) => {
      const item = {
        campaign: d.name,
        company: d.company?.name,
        seller: `${d.user?.name} ${d.user?.familyName}`,
        start: d.start,
        end: d.end,
        sites: this.getSites(d.lineItems)
          .map((s) => s.abbreviation)
          .join(" | "),
        status: this.getStatus(d.status),
      };
      data.push(item);
    });

    exportCSVFile(
      headers,
      data,
      `campaigns_${moment(this.filter.start).format("YYYY_MM_DD")}_to_${moment(
        this.filter.end
      ).format("YYYY_MM_DD")}`
    );
  }

  get filter() {
    return { start: ReportModule.startFilter, end: ReportModule.endFilter };
  }

  showFilter(): void {
    LayoutModule.setRightDrawerComponent(CampaignsReportFilter);
    LayoutModule.showRightDrawer();
  }

  campaignStatusColor(status: string): string {
    return CampaignHelper.getColorClass(status);
  }

  getSites(lineItems: LineItem[]): Site[] {
    const sitesIds: string[] = [];
    const sites: Site[] = [];
    lineItems.forEach((l) => {
      !sitesIds.includes(l.siteId) ? sitesIds.push(l.siteId) : null;
    });

    sitesIds.forEach((s) => {
      const site = this.sites.find((i) => i.id === s);
      site ? sites.push(site) : null;
    });

    return sites;
  }

  getStatus(status: string): string {
    const s = CAMPAIGN_STATUS_LIST.find((s) => s.key === status);

    return s ? this.$t(s?.label).toString() : "";
  }
}
